export const VENDOR_CATEGORIES = ['WO', 'Venue', 'Catering', 'Dekorasi', 'Foto & Video', 'MUA', 'Busana', 'Entertainment', 'Lainnya'];

export const VENDOR_VERIFY_CATEGORIES = [
  {
    id: 'identitas',
    title: 'Identitas & Kontak',
    items: [
      { key: 'nama_bisnis', label: 'Nama bisnis dicatat' },
      { key: 'pic_jelas', label: 'PIC utama jelas' },
      { key: 'kontak_aktif', label: 'Nomor kontak aktif' },
      { key: 'lokasi', label: 'Lokasi / alamat diketahui' },
      { key: 'nama_penerima', label: 'Nama penerima pembayaran dicatat' },
    ],
  },
  {
    id: 'portfolio',
    title: 'Portfolio & Referensi',
    items: [
      { key: 'portfolio_dilihat', label: 'Portfolio acara nyata sudah dilihat' },
      { key: 'acara_terbaru', label: 'Beberapa acara terbaru bisa ditelusuri' },
      { key: 'venue_partner', label: 'Venue / vendor partner dikonfirmasi jika relevan' },
      { key: 'referensi', label: 'Referensi pelanggan diperiksa jika memungkinkan' },
    ],
  },
  {
    id: 'kontrak',
    title: 'Kontrak & Scope',
    items: [
      { key: 'scope', label: 'Scope pekerjaan tertulis jelas' },
      { key: 'deliverables', label: 'Deliverables utama tercantum' },
      { key: 'jadwal_kerja', label: 'Jadwal pekerjaan jelas' },
      { key: 'jadwal_bayar', label: 'Jadwal pembayaran tertulis' },
      { key: 'ketentuan_perubahan', label: 'Ketentuan perubahan tersedia' },
      { key: 'ketentuan_pembatalan', label: 'Ketentuan pembatalan tersedia' },
      { key: 'refund', label: 'Ketentuan refund dipahami jika relevan' },
    ],
  },
  {
    id: 'pembayaran',
    title: 'Pembayaran',
    items: [
      { key: 'rek_penerima', label: 'Nama rekening penerima dicatat' },
      { key: 'penerima_konfirmasi', label: 'Nama penerima dikonfirmasi ke PIC' },
      { key: 'nominal_sesuai', label: 'Nominal sesuai kesepakatan' },
      { key: 'tahapan_sesuai', label: 'Tahapan pembayaran sesuai kontrak' },
      { key: 'bukti_sebelumnya', label: 'Bukti pembayaran sebelumnya tersedia' },
    ],
  },
];

export const ALL_VERIFY_ITEMS = VENDOR_VERIFY_CATEGORIES.flatMap((c) => c.items.map((i) => ({ ...i, category: c.title })));

export const GUARD_CHECKLIST = [
  {
    id: 'dokumen',
    title: 'Dokumen',
    items: [
      { key: 'kontrak_tersedia', label: 'Kontrak tersedia' },
      { key: 'scope_jelas', label: 'Scope pekerjaan jelas' },
      { key: 'jadwal_cocok', label: 'Jadwal pembayaran cocok dengan kontrak' },
      { key: 'perubahan_ditinjau', label: 'Ketentuan perubahan / pembatalan sudah ditinjau' },
    ],
  },
  {
    id: 'penerima',
    title: 'Penerima Pembayaran',
    items: [
      { key: 'nama_dicatat', label: 'Nama penerima sudah dicatat' },
      { key: 'rekening_konfirmasi', label: 'Informasi rekening dikonfirmasi ke PIC' },
      { key: 'nominal_kesepakatan', label: 'Nominal sesuai kesepakatan' },
      { key: 'tahap_sesuai', label: 'Pembayaran ini sesuai tahap yang disepakati' },
    ],
  },
  {
    id: 'kesiapan',
    title: 'Kesiapan Vendor',
    items: [
      { key: 'verify_ditinjau', label: 'Vendor Verify sudah ditinjau' },
      { key: 'terbuka_dipahami', label: 'Hal penting yang masih terbuka sudah dipahami' },
      { key: 'partner_konfirmasi', label: 'Partner penting sudah dikonfirmasi jika relevan' },
    ],
  },
  {
    id: 'setelah',
    title: 'Setelah Transfer',
    items: [
      { key: 'bukti_disimpan', label: 'Bukti pembayaran akan disimpan' },
      { key: 'tanggal_dicatat', label: 'Tanggal transfer akan dicatat' },
      { key: 'nominal_dicatat', label: 'Nominal akan dicatat' },
      { key: 'invoice_disimpan', label: 'Tanda terima / invoice akan disimpan jika tersedia' },
    ],
  },
];

export const ALL_GUARD_ITEMS = GUARD_CHECKLIST.flatMap((g) => g.items.map((i) => ({ ...i, group: g.title })));

export const GUARD_CRITICAL_GROUPS = ['dokumen', 'penerima', 'kesiapan'];

export const VENDOR_QUESTIONS = {
  ketentuan_pembatalan: '“Jika acara berubah atau dibatalkan, bagaimana ketentuan DP yang sudah dibayarkan?”',
  ketentuan_perubahan: '“Jika tanggal atau konsep acara berubah, apa saja yang bisa disesuaikan tanpa biaya tambahan?”',
  penerima_konfirmasi: '“Boleh saya konfirmasi nama pemilik rekening yang akan menerima pembayaran berikutnya?”',
  rek_penerima: '“Boleh saya minta nama pemilik rekening sesuai yang tertera di buku tabungan?”',
  referensi: '“Boleh saya minta kontak satu atau dua pelanggan sebelumnya sebagai referensi?”',
  jadwal_bayar: '“Boleh saya minta jadwal pembayaran tertulis yang disepakati kedua pihak?”',
  refund: '“Dalam kondisi apa DP bisa dikembalikan, sebagian atau penuh?”',
  portfolio_dilihat: '“Boleh saya lihat dokumentasi acara terbaru yang dikerjakan tim ini?”',
};

export const GUARD_ASK_MESSAGES = {
  kontrak_tersedia: 'Halo Kak, sebelum pembayaran berikutnya, boleh saya minta salinan kontrak / SPK yang sudah ditandatangani?',
  scope_jelas: 'Halo Kak, boleh saya konfirmasi ulang scope pekerjaan yang tertulis untuk paket kami?',
  jadwal_cocok: 'Halo Kak, boleh saya konfirmasi jadwal pembayaran tertulisnya? Saya ingin memastikan tahap berikutnya sudah sesuai kontrak.',
  perubahan_ditinjau: 'Halo Kak, saya ingin konfirmasi ketentuan pembatalan / perubahan untuk pembayaran berikutnya. Apakah ada poin tertulis yang bisa saya cek?',
  nama_dicatat: 'Halo Kak, boleh saya konfirmasi nama pemilik rekening yang akan menerima pembayaran berikutnya?',
  rekening_konfirmasi: 'Halo Kak, untuk pembayaran berikutnya, apakah rekening tujuan masih sama? Boleh saya konfirmasi atas nama siapa?',
  nominal_kesepakatan: 'Halo Kak, saya ingin memastikan nominal pembayaran tahap berikutnya sudah sesuai kesepakatan. Terima kasih.',
  tahap_sesuai: 'Halo Kak, pembayaran berikutnya ini termasuk tahap yang mana ya dalam kesepakatan kita?',
  verify_ditinjau: 'Halo Kak, ada beberapa detail yang ingin saya pastikan kembali sebelum pembayaran berikutnya. Kapan saya bisa menghubungi?',
  terbuka_dipahami: 'Halo Kak, ada beberapa hal yang masih ingin saya pastikan sebelum pembayaran berikutnya. Boleh saya tanyakan?',
  partner_konfirmasi: 'Halo Kak, untuk hari H, apakah ada vendor / venue rekanan yang perlu kami konfirmasi juga?',
};

export const MONEY_KEYS = ['scope', 'deliverables', 'jadwal_bayar', 'ketentuan_perubahan', 'ketentuan_pembatalan', 'refund', 'nama_penerima', 'rek_penerima', 'penerima_konfirmasi', 'nominal_sesuai', 'tahapan_sesuai'];

export const VERIFY_SHORT = {
  nama_bisnis: 'nama bisnis',
  pic_jelas: 'PIC utama',
  kontak_aktif: 'kontak aktif',
  lokasi: 'lokasi vendor',
  nama_penerima: 'nama penerima pembayaran',
  portfolio_dilihat: 'portfolio acara',
  acara_terbaru: 'acara terbaru',
  venue_partner: 'konfirmasi venue partner',
  referensi: 'referensi pelanggan',
  scope: 'scope pekerjaan',
  deliverables: 'deliverables utama',
  jadwal_kerja: 'jadwal pekerjaan',
  jadwal_bayar: 'jadwal pembayaran',
  ketentuan_perubahan: 'ketentuan perubahan',
  ketentuan_pembatalan: 'ketentuan pembatalan',
  refund: 'ketentuan refund',
  rek_penerima: 'nama rekening penerima',
  penerima_konfirmasi: 'nama penerima pembayaran',
  nominal_sesuai: 'nominal kesepakatan',
  tahapan_sesuai: 'tahapan pembayaran',
  bukti_sebelumnya: 'bukti pembayaran sebelumnya',
};

export const VERIFY_NEXT_STEP = {
  scope: 'Pastikan scope pekerjaan tertulis sebelum {stage}.',
  deliverables: 'Pastikan deliverables utama tercantum sebelum {stage}.',
  jadwal_bayar: 'Minta jadwal pembayaran tertulis sebelum {stage}.',
  ketentuan_perubahan: 'Tanyakan ketentuan perubahan acara sebelum {stage}.',
  ketentuan_pembatalan: 'Tanyakan ketentuan pembatalan sebelum {stage}.',
  refund: 'Pahami ketentuan refund sebelum {stage}.',
  nama_penerima: 'Catat nama penerima pembayaran sebelum {stage}.',
  rek_penerima: 'Catat nama pemilik rekening sebelum {stage}.',
  penerima_konfirmasi: 'Konfirmasi nama penerima ke PIC sebelum {stage}.',
  nominal_sesuai: 'Cocokkan nominal dengan kesepakatan sebelum {stage}.',
  tahapan_sesuai: 'Pastikan tahapan pembayaran sesuai kontrak sebelum {stage}.',
};
